/*
 * As titled, this function will take a new array element,
 * and will either replace an existing element in the array
 * or append itself to the array if the element doesn't exist.
 *
 * array: Target array to either replace or append to
 * itemKey: Key to compare the targetValue against
 * targetValue: Value to compare against each array elements itemKey
 * newElement: Element to append or replace with
 */
export const replaceOrCreateObjectInArray = ({
  array,
  itemKey,
  targetValue,
  newElement,
}) => {
  const index = array.findIndex(
    obj => obj && itemKey in obj && obj[itemKey] === targetValue,
  )

  if (index === -1) {
    return [...array, newElement]
  }
  const newArray = [...array]

  newArray[index] = newElement

  return newArray
}
